import { query } from '@/utils/request';

// 获取日志列表
export async function getLogList(params) {
  return query('/zlb/operation/log/list', { params });
}

// 获取日志类型
export async function getLogTypeList() {
  return query('/zlb/operation/log/bizActionItems');
}

// 获取档案异常日志列表
export async function getArchiveLogList(data) {
  return query('/zlb/api/sop/archive/errorLog/list', {
    method: 'post',
    data,
  });
}
